"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RandomString_1 = __importDefault(require("@CommonFrontendBackend/Utils/RandomString"));
module.exports = (function () {
    function Utils($timeout, $q, uniqueId) {
        this.id = uniqueId;
        this.randomString = RandomString_1.default;
        this.scrollToBlock = function (blockId) {
            return $timeout(function () {
                return $("html, body").animate({
                    scrollTop: $(".project-block[block-id=".concat(blockId, "]")).offset().top,
                }, 400);
            });
        };
        this.delay = function (duration) {
            var delaying = $q.defer();
            $timeout(function () { return delaying.resolve(); }, duration);
            return delaying.promise;
        };
    }
    return Utils;
}());
